export enum MinorSections {
  Home = 'HOME',
  MinorsDetails = 'MINOR',
  Subscriber = 'SUBSCRIBER',
  Assets = 'ASSETS',
  Documents = 'DOCUMENTS',
  Forms = 'FORMS',
  Taxes = 'TAXES',
  BondSurety = 'BOND_SURETY',
  Notes = 'NOTES',
  Notifications = 'NOTIFICATIONS',
  Messages = 'MESSAGES',
}
